module.exports = __webpack_public_path__ + "img/play.0900abfd.svg";